import { render, staticRenderFns } from "./FormTabs.vue?vue&type=template&id=48a9701c&scoped=true&lang=pug&"
import script from "./FormTabs.vue?vue&type=script&lang=js&"
export * from "./FormTabs.vue?vue&type=script&lang=js&"
import style0 from "./FormTabs.vue?vue&type=style&index=0&id=48a9701c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9701c",
  null
  
)

export default component.exports